<template>
  <div>
    <el-row>
      <el-col :span="24">
        <!-- <el-button
          style="padding: 0; margin: 20px"
          type="text"
          icon="el-icon-back"
          @click="$router.go(-1)"
        >
          返回
        </el-button> -->
        <el-button
          type="primary"
          size="mini"
          @click="
            search.chooseOrgVisible = true;
            searchData();
          "
        >
          赠送课程
        </el-button>
        <el-button type="primary" size="mini" @click="dialogVisible2 = true;"> 赠送遇见门票券 </el-button>
        <el-button type="primary" size="mini" @click="dialogVisible3 = true; info.present_target_id = '10';"> 赠送会员 </el-button>
        <el-button type="primary" v-if="this.query.item_type == 2" :disabled="psyItemStatus == 0" size="mini" @click="choosePsyItemVisible = true; info.present_target_id = '10';getPsyItemList()"> 赠送心理咨询套餐 </el-button>
        <el-button type="primary" v-if="this.query.item_type == 11 && this.query.target_id == 410"  size="mini" @click="chooseProductVisible = true;searchProductData()"> 赠送电商实物商品 </el-button>
      </el-col>
    </el-row>

    <el-row>
      <el-table
        v-loading="loading"
        :data="list"
        border
        size="mini"
        :stripe="true"
        style="width: 100%; margin: 20px 0"
      >
        <el-table-column
          label="赠送类型"
          align="center"
          min-width="8%"
          prop="present_item_type_msg"
        ></el-table-column>

        <el-table-column label="赠送对象ID" align="center" min-width="8%">
          <template slot-scope="{ row }">
            {{
              row.present_target_id +
              (row.present_object_id > 0 ? " | " + row.present_object_id : "")
            }}
          </template>
        </el-table-column>
        <el-table-column label="赠送对象" align="center" min-width="20%">
          <template slot-scope="{ row }">
            {{
              row.present_target_name +
              (row.present_item_type == 15 ? " " + row.amount + "张" : "")
            }}
          </template>
        </el-table-column>
        <el-table-column v-if="query.item_type == 11 && query.target_id == 410" align="center" min-width="13%">
          <template slot="header">
            <div>赠送起止时间<span style="color: red; font-size: 10px;">（实物赠品设置起止时间后生效）</span></div>

          </template>
          <template slot-scope="{ row }">
            <div>{{ row.begin_at ? (row.begin_at+' 至 '+row.end_at) : '' }}</div>
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" min-width="10%">
          <template slot-scope="{ row }">
            <el-button type="warning" size="mini" v-if="query.item_type == 11 && query.target_id == 410 && row.present_item_type == 7" @click="presentRelationshipTimeEdit(row.id)">
              编辑
            </el-button>
            <el-button
              type="danger"
              size="mini"
              @click="presentRelationshipDel(row.id)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <div class="block">
        <el-pagination
          background
          @current-change="getList"
          :current-page.sync="query.page"
          :page-size="query.limit"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </el-row>

    <el-dialog
      title="选择商品"
      :visible.sync="search.chooseOrgVisible"
      :close-on-click-modal="true"
      :before-close="addEditFormOnClose"
      width="75%"
    >
      <el-form :inline="true" :model="search.query">
        <!-- 模糊查询 -->
        <el-form-item>
          <el-input
            size="small"
            v-model="search.query.search"
            placeholder="请输入标题"
            clearable
            @blur="searchData()"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="searchData()">
            查询
          </el-button>
        </el-form-item>
      </el-form>

      <el-tabs v-model="search.activeName" @tab-click="handleClick">
        <el-tab-pane label="普通课程" name="1"></el-tab-pane>
        <el-tab-pane label="直播课" name="3"></el-tab-pane>
        <el-tab-pane label="线下课" name="5"></el-tab-pane>
        <el-tab-pane label="专题课" name="12"></el-tab-pane>
      </el-tabs>

      <!--列表-->
      <el-table
        border
        :data="search.result.data"
        highlight-current-row
        v-loading="search.listLoading1"
        style="..."
      >
        <el-table-column prop="id" label="ID" align="center"></el-table-column>
        <el-table-column
          prop="title"
          label="标题"
          align="center"
        ></el-table-column>
        <el-table-column label="图片" align="center">
          <template slot-scope="{ row }">
            <img :src="row.img_url" style="width: 40px" alt="" />
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="{ row }">
            <el-button type="primary" size="small" @click="selectProduct(row)">
              确定
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @current-change="searchData"
        :current-page.sync="search.query.page"
        :page-size="search.query.limit"
        layout="total, prev, pager, next, jumper"
        :total="search.result.total"
      >
      </el-pagination>
    </el-dialog>

    <el-dialog
      title="选择课期"
      :visible.sync="search2.chooseOrgVisible"
      :close-on-click-modal="true"
      :before-close="addEditFormOnClose2"
      width="75%"
    >
      <!--列表-->
      <el-table
        border
        :data="search2.result.data"
        highlight-current-row
        v-loading="search2.listLoading1"
        style="..."
      >
        <el-table-column prop="id" label="ID" align="center"></el-table-column>

        <el-table-column label="课期" align="center">
          <template slot-scope="{ row }">
            {{ formatDateTime(row) }}
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="{ row }">
            <el-button type="primary" size="small" @click="selectProduct2(row)">
              确定
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        :current-page.sync="search2.query.page"
        :page-size="search2.query.limit"
        layout="total, prev, pager, next, jumper"
        :total="search2.result.total"
      >
      </el-pagination>
    </el-dialog>

    <el-dialog
      title="设置遇见门票券数量"
      :visible.sync="dialogVisible2"
      :close-on-click-modal="true"
      :before-close="addEditFormOnClose3"
      width="50%"
    >        
      <el-input
        v-model="info.amount"
        style="width:66%; margin-left: 256 /2; position: relative; left: 10%;"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="info.present_item_type = 15; info.present_target_id = 1648; doAdd()"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      title="设置赠送会员"
      :visible.sync="dialogVisible3"
      :close-on-click-modal="true"
      :before-close="addEditFormOnClose4"
      width="50%"
    >        
      <el-radio v-model="info.present_target_id" label="10">365幸福会员</el-radio>
      <el-radio v-model="info.present_target_id" label="2">7天免费会员</el-radio>
      <el-radio v-model="info.present_target_id" label="3">15天免费会员</el-radio>
      <el-radio v-model="info.present_target_id" label="4">月卡会员</el-radio>
      <el-radio v-model="info.present_target_id" label="6">季卡会员</el-radio>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="info.present_item_type = 1; doAdd()"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!--商品-->
    <el-dialog
        title="选择商品"
        :visible.sync="choosePsyItemVisible"
        :close-on-click-modal="true"
        :before-close="addPsyItemOnCloseProduct"
        width="75%"
    >
      <el-form :inline="true" :model="psyItemList.query">
        <!-- 模糊查询 -->
<!--        <el-form-item>
          <el-input
              size="small"
              v-model="product.query.search"
              placeholder="输入标题或ID"
              clearable
              @blur="searchDataProduct()"
          />
        </el-form-item>-->
        <el-form-item>
          <el-button
              type="primary"
              size="small"
              @click="
              getPsyItemList();psyItemList.query.page = 1
            "
          >
            刷新
          </el-button>
        </el-form-item>
      </el-form>

      <!--列表-->
      <el-table
          border
          :data="psyItemList.data"
          highlight-current-row
          v-loading="psyItemList.itemListLoading"
          style=""
      >
        <el-table-column prop="id" label="ID" align="center"></el-table-column>
        <el-table-column
            prop="name"
            label="套餐名称"
            align="center"
        ></el-table-column>
        <el-table-column
            prop="intro"
            label="套餐介绍"
            align="center"
        ></el-table-column>
        <el-table-column
            prop="counselor_num"
            label="咨询师数量"
            align="center"
        ></el-table-column>

        <el-table-column
            prop="give_num"
            label="赠送次数"
            align="center"
        >

          <template slot-scope="{ row }">
            <el-input v-model="row.give_num" min="1"  oninput="this.value=this.value.replace(/[^0-9]/g,'')"  placeholder="" />
          </template>
          </el-table-column>

        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="{ row }">
            <el-button type="primary" size="small" @click="selectItemPackage(row)">
              确定
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          background
          @current-change="getPsyItemList"
          :current-page.sync="psyItemList.query.page"
          :page-size="psyItemList.query.limit"
          layout="total, prev, pager, next, jumper"
          :total="psyItemList.total"
      >
      </el-pagination>
    </el-dialog>

    <!-- 编辑时间对话框 -->
    <el-dialog
      title="编辑时间"
      :visible.sync="editTimeVisible"
      :close-on-click-modal="false"
      width="50%"
    >
      <el-form :model="editTimeForm" label-width="120px">
        <el-form-item label="开始时间">
          <el-date-picker
            v-model="editTimeForm.begin_at"
            type="datetime"
            placeholder="选择开始时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            default-time="00:00:00"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="结束时间">
          <el-date-picker
            v-model="editTimeForm.end_at"
            type="datetime"
            placeholder="选择结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 100%"
            default-time="23:59:59"
          />
        </el-form-item>
        <el-form-item label="赠送数量">
          <el-input
              oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/^0+/, '') || ''"
              v-model="editTimeForm.amount"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editTimeVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveEditTime">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
        title="添加赠品"
        :visible.sync="chooseProductVisible"
        :close-on-click-modal="true"
        :before-close="addProductOnCloseProduct"
        width="75%"
    >
      <el-form :inline="true" :model="productList.query">
        <!-- 模糊查询 -->
        <el-form-item>
          <el-input
              size="small"
              v-model="productList.query.search"
              placeholder="请输入标题"
              clearable
              @blur="searchProductData(now_index)"
          />
        </el-form-item>
        <el-form-item>
          <el-button
              type="primary"
              size="small"
              @click="
              searchProductData(now_index);
            "
          >
            查询
          </el-button>
        </el-form-item>
      </el-form>

      <el-tabs v-model="search.activeName" @tab-click="handleClick">
        <el-tab-pane label="商品" name="1"></el-tab-pane>
        <!--                  <el-tab-pane label="读书音频" name="6"></el-tab-pane>-->
      </el-tabs>

      <!--列表-->
      <el-table
          border
          :data="productList.data"
          highlight-current-row
          v-loading="productList.itemListLoading"
          style="..."
          @expand-change="expandChange"
      >
        <el-table-column type="expand" >
          <template slot-scope="props">
            <el-table border v-loading="productList.skuListLoading" :data="props.row.breBroodsList" size="mini" style="width: 92%;margin-left: 4%;">
              <el-table-column prop="id" label="ID" align="center"></el-table-column>
              <el-table-column prop="sku_title" label="标题" ></el-table-column>
              <el-table-column prop="created_at" label="图片">
                <template slot-scope="{ row }">
                  <img :src="row.img_url" style="width: 40px" alt="" />
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="200">
                <template slot-scope="{ row }">
                  <el-button type="primary" size="small" @click="selectProductDianShang(row)">
                    确定
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>

        <el-table-column prop="id" label="ID" align="center"></el-table-column>
        <el-table-column
            prop="title"
            label="标题"
            align="center"
        ></el-table-column>
        <el-table-column label="图片" align="center">
          <template slot-scope="{ row }">
            <img :src="row.img_url" style="width: 40px" alt="" />
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          background
          @current-change="pageSearchData"
          :current-page.sync="productList.query.page"
          :page-size="productList.query.limit"
          layout="total, prev, pager, next, jumper"
          :total="productList.total"
      >
      </el-pagination>
    </el-dialog>
  </div>
</template>

<script>
import {
  presentRelationshipList,
  presentRelationshipAdd,
  presentRelationshipDel,
  presentRelationshipEdit,
  getPsyItems,
} from "@/api/order";

import { screenProductList } from "@/api/coupon";

import { getCourseTermList } from "@/api/course";

import { formatDateTime } from "@/api/common";
import {
  getSkuList
} from "@/api/productActivity";

export default {
  data: function () {
    return {
      list: [],
      loading: false,
      dialogVisible2: false,
      dialogVisible3: false,
      choosePsyItemVisible: false,//心理咨询套餐
      chooseProductVisible: false,//心理咨询套餐
      psyItemStatus: 0,//心理咨询套餐是否可以设置的状态
      editTimeVisible: false,//编辑时间对话框
      editTimeForm: {
        id: 0,
        begin_at: '',
        end_at: '',
        amount: 1,
      },
      total: 0,
      query: {
        item_type: this.$route.query.item_type,
        target_id: this.$route.query.target_id,
        object_id: this.$route.query.object_id,
        page: 1,
        limit: 20,
      },
      search: {
        chooseOrgVisible: false,
        listLoading1: false,
        activeName: "1",
        query: {
          type: 1,
          search: "",
          page: 1,
          limit: 5,
          target_type: 1,
        },
        result: {
          total: 0,
          data: [],
        },
      },
      psyItemList:{
        query:{
          page:1,
          limit:10,
          target:'present'
        },
        itemListLoading:false,
        total: 0,
        data: [],
      },
      productList:{
        query:{
          page:1,
          limit:5,
          target_type: 0,
        },
        itemListLoading:false,
        skuListLoading:false,
        total: 0,
        data: [],
      },
      info: {
        item_type: this.$route.query.item_type,
        target_id: this.$route.query.target_id,
        object_id: this.$route.query.object_id,
        present_item_type: 2,
        present_target_id: 0,
        present_object_id: 0,
        amount: 0,
      },
      search2: {
        chooseOrgVisible: false,
        listLoading1: false,
        query: {
          id: 0,
          page: 1,
          limit: 5,
          status: 1,
        },
        result: {
          total: 0,
          data: [],
        },
      },
    };
  },
  created: function () {
    this.getList();
  },
  methods: {
      addEditFormOnClose4() {
        this.dialogVisible3 = false;
        this.info.present_item_type = 1;
        this.info.present_target_id = 0;
    },
    addEditFormOnClose3() {
        this.dialogVisible2 = false;
        this.info.present_item_type = 1;
        this.info.present_target_id = 0;
    },
    formatDateTime(row) {
      return (
        row.title +
        (row.start_at === null
          ? ""
          : " " + formatDateTime(row.start_at, "yyyy-MM-dd hh:mm")) +
        (row.end_at === null
          ? ""
          : "~" + formatDateTime(row.end_at, "MM-dd hh:mm"))
      );
    },
    // 弹窗关闭
    addEditFormOnClose2() {
      this.search2.query.id = 0;
      this.search2.query.page = 1;
      this.search2.query.status = 1;

      this.info.present_object_id = 0;

      this.search2.result = {
        total: 0,
        data: [],
      };
      this.search2.chooseOrgVisible = false;
    },
    handleClick(tab, event) {
      this.search.query.target_type = Number(tab.name);
      this.searchData();
      //   if (this.search.query.target_type == 12) {
      //     this.info.present_item_type = 12;
      //   } else if (this.search.query.target_type == 1) {
      //     this.info.present_item_type = 2;
      //   } else if (this.search.query.target_type == 3) {
      //     this.info.present_item_type = 5;
      //   } else if (this.search.query.target_type == 5) {
      //     this.info.present_item_type = 3;
      //   }
    },
    // 弹窗关闭
    addEditFormOnClose() {
      this.search.query.page = 1;
      this.search.activeName = "1";
      this.search.query.type = 1;
      this.search.query.search = "";
      this.search.query.target_type = 1;

      this.search.result = {
        total: 0,
        data: [],
      };
      this.search.chooseOrgVisible = false;

      this.info.present_item_type =
        this.info.present_target_id =
        this.info.present_object_id =
        this.info.amount =
          0;
    },
    // 查询方法
    searchData() {
      this.search.listLoading1 = true;
      screenProductList(this.search.query).then((response) => {
        this.search.result.data = response.data.list;
        this.search.result.total = response.data.total;
        this.search.listLoading1 = false;
      });
    },
    selectProduct(row) {
      this.info.present_item_type = row.course_type;
      this.info.present_target_id = row.id;
      if (row.extra_type == 1) {
        //属于排期课
        this.search2.chooseOrgVisible = this.search2.listLoading1 = true;
        this.search2.query.id = row.id;
        getCourseTermList(this.search2.query).then((response) => {
          this.search2.result.data = response.data.list;
          this.search2.result.total = response.data.total;
          this.search2.listLoading1 = false;
        });
      } else {
        //非排期课
        this.doAdd();
        this.search.chooseOrgVisible = false;
      }
    },

    selectItemPackage(row) {//选择套餐包
        if(row.give_num < 1){
          this.$message({
            showClose: true,
            message: "仅支持输入正整数",
            type: "error",
          });
          return false;
        }
      if(row.give_num == ""){
        this.$message({
          showClose: true,
          message: "请输入赠送次数",
          type: "error",
        });
        return false;
      }
      if(row.give_num > row.counselor_num){
        this.$message({
          showClose: true,
          message: "赠送次数需小于等于咨询师数量",
          type: "error",
        });
        return false;
      }
      this.info.present_item_type = 20;
      this.info.present_target_id = row.id;
      this.info.amount = row.give_num;
      //非排期课
      this.doAdd();
      this.search.chooseOrgVisible = false;
    },

    selectProduct2(row) {
      this.info.present_object_id = row.id;
      this.doAdd();
      this.search2.chooseOrgVisible = false;
    },

    getPsyItemList(){
        this.psyItemList.itemListLoading = true;
      getPsyItems(this.psyItemList.query).then((response) => {
        this.psyItemList.data = response.data.list;
        this.psyItemList.total = response.data.total;
        this.psyItemList.itemListLoading = false;
        if(this.psyItemList.total == 0){
          this.$message({
            showClose: true,
            message: '无上架咨询套餐可选',
            type: "error",
          });
        }
      });
    },
    // 弹窗关闭
    addPsyItemOnCloseProduct() {
      this.psyItemList.data = [];
      this.psyItemList.total = 0;
      this.psyItemList.query.page = 1;
      this.choosePsyItemVisible = false;
    },

    doAdd() {
      this.$confirm("是否确定设置此赠送对象?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        presentRelationshipAdd(this.info).then((response) => {
          this.addEditFormOnClose();
          this.addEditFormOnClose2();
          this.addEditFormOnClose3();
          this.addEditFormOnClose4();
          this.addPsyItemOnCloseProduct();
          this.addProductOnCloseProduct();
          if (response.status == 2000) {
            this.getList();
            this.$message({
              showClose: true,
              message: "成功",
              type: "success",
            });
          } else {
            /*this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });*/
          }
        });
      }).catch(() => {});
    },

    // 查询电商商品 电商赠品开始
    searchProductData(index) {
      this.now_index = index;
      this.productList.itemListLoading = true;
      screenProductList(this.productList.query).then((response) => {
        this.productList.data = response.data.list;
        this.productList.total = response.data.total;
        this.productList.itemListLoading = false;
      });
    },
    /**点击主表格行，获取子表格明细**/
    expandChange(val) {
      console.log(val)
      val.breBroodsList = undefined;
      this.theTargetId = val.id;
      this.theTargetTitle = val.title;
      this.productList.skuListLoading = true;
      if (val.breBroodsList == undefined) {
        getSkuList({product_id: val.id}).then(res => {
          this.$set(val, 'breBroodsList', res.data.list)
          this.productList.skuListLoading = false;
        })
      }
    },
    selectProductDianShang(row) {
      this.info.present_item_type = 7;
      this.info.present_target_id = row.product_id;
      this.info.present_object_id = row.id;
      this.info.amount = 1;
      this.doAdd();
      //this.addProductOnCloseProduct();
    },
    pageSearchData() {
      this.searchProductData(this.now_index);
    },
    // 弹窗关闭
    addProductOnCloseProduct() {
      this.productList.data = [];
      this.productList.total = 0;
      this.productList.query.page = 1;
      this.chooseProductVisible = false;
    },
    //电商赠品结束

    getList() {
      this.loading = true;
      presentRelationshipList(this.query).then((response) => {
        this.list = response.data.list;
        this.total = response.data.total;
        this.psyItemStatus = response.data.psy_item_status;
        this.loading = false;
      });
    },

    presentRelationshipDel(id) {
      this.$confirm("此操作将删除该对象, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        presentRelationshipDel({
          id: id,
        }).then((response) => {
          if (response.status == 2000) {
            this.getList();
            this.$message({
              showClose: true,
              message: "删除成功",
              type: "success",
            });
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        });
      });
    },

    // 打开编辑时间对话框
    presentRelationshipTimeEdit(id) {
      const row = this.list.find(item => item.id === id);
      console.log(row)
      if (row) {
        this.editTimeForm.id = row.id;
        this.editTimeForm.begin_at = row.begin_at || '';
        this.editTimeForm.end_at = row.end_at || '';
        this.editTimeForm.amount = row.amount ? row.amount : 1;
        this.editTimeVisible = true;
      }
    },

    // 保存编辑的时间
    saveEditTime() {
      if (!this.editTimeForm.begin_at || !this.editTimeForm.end_at) {
        this.$message({
          showClose: true,
          message: "请选择开始时间和结束时间",
          type: "error",
        });
        return;
      }
      if (this.editTimeForm.begin_at > this.editTimeForm.end_at) {
        this.$message({
          showClose: true,
          message: "开始时间不能大于结束时间",
          type: "error",
        });
        return;
      }
      if (this.editTimeForm.amount < 1) {
        this.$message({
          showClose: true,
          message: "数量不能小于1",
          type: "error",
        });
        return;
      }

      presentRelationshipEdit({
        id: this.editTimeForm.id,
        begin_at: this.editTimeForm.begin_at,
        end_at: this.editTimeForm.end_at,
        amount: this.editTimeForm.amount,
      }).then((response) => {
        if (response.status == 2000) {
          this.editTimeVisible = false;
          this.getList();
          this.$message({
            showClose: true,
            message: "编辑成功",
            type: "success",
          });
        } else {
          this.$message({
            showClose: true,
            message: response.message || "编辑失败",
            type: "error",
          });
        }
      }).catch(() => {
        this.$message({
          showClose: true,
          message: "编辑失败",
          type: "error",
        });
      });
    },
  },
  mounted() {},
};
</script>

<style>
</style>